/**
 * Shown in place of a route page while its chunk loads. Rendered where the page
 * itself renders, so an authenticated route keeps the chrome around it.
 */
export function RouteFallback() {
  return (
    <div
      className="flex min-h-[40vh] w-full items-center justify-center p-6 text-sm text-muted-foreground"
      role="status"
      data-testid="route-fallback"
    >
      Loading…
    </div>
  );
}
